import { makeStyles } from '@fluentui/react-components';

export const useVideoThumbnailStyles = makeStyles({
  container: {
    position: 'relative',
    display: 'inline-block',
    textAlign: 'center',
    width: '100%',
  },
  playBtn: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    cursor: 'pointer',
  },
  noVideo: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
  },
});
